module.exports = {
  title: "Arduino සරලව",
  slug: "arduino",
  videos: [
    {
      id: 1,
      title: "Arduino සරලව: Tinkercad හඳුන්වාදීම",
      link: "https://www.youtube.com/embed/WCTQ_PNr5kQ",
    },
    {
      id: 2,
      title: "Arduino සරලව: 1 පාඩම: Arduino සහ LED",
      link: "https://www.youtube.com/embed/IgC-hXxiku4",
    },
    {
      id: 3,
      title: "Arduino සරලව: 1 පාඩම: LED සහ Breadboard",
      link: "https://www.youtube.com/embed/ZVHlDMac5C0",
    },
    {
      id: 4,
      title: "Arduino සරලව: 1 පාඩම: Kirchoff's voltage නියමය - PART  1",
      link: "https://www.youtube.com/embed/_xHzmjgoSOY",
    },
    {
      id: 5,
      title: "Arduino සරලව: 1 පාඩම: Kirchoff's voltage නියමය - PART  2",
      link: "https://www.youtube.com/embed/otqKfJUBtII",
    },
    {
      id: 6,
      title: "Arduino සරලව: 1 පාඩම: පරිපථ ගැන තවත්",
      link: "https://www.youtube.com/embed/s3Mhftzz3YI",
    },
    {
      id: 7,
      title: "Arduino සරලව: 1 පාඩම: 7 segment display ඇසුරින් ඉලක්කම්",
      link: "https://www.youtube.com/embed/UHVc5-vOgjc",
    },
    {
      id: 8,
      title: "Arduino සරලව: 2 පාඩම: හඳුන්වාදීම input සහ output",
      link: "https://www.youtube.com/embed/4nqpmKMpDRQ",
    },
    {
      id: 9,
      title: "Arduino සරලව: 2 පාඩම: Digital input සහ output",
      link: "https://www.youtube.com/embed/yGoBx6tefIg",
    },
    {
      id: 10,
      title: "Arduino සරලව: 2 පාඩම: Analog Input",
      link: "https://www.youtube.com/embed/6CLbTfx-oJc",
    },
    {
      id: 11,
      title: "Arduino සරලව: 2 පාඩම: Analog Output",
      link: "https://www.youtube.com/embed/Hm0zHWwIsPw",
    },
    {
      id: 12,
      title: "Arduino සරලව: 3 පාඩම: Actuators හඳුන්වාදීම සහ DC motors",
      link: "https://www.youtube.com/embed/Z-s7KPl_EPk",
    },
    {
      id: 13,
      title: "Arduino සරලව: 3 පාඩම: Analog output සහ  piezo speaker",
      link: "https://www.youtube.com/embed/uWkWTvGOIJU",
    },
    {
      id: 14,
      title: "Arduino සරලව: 3 පාඩම: Servo motor - PART 1",
      link: "https://www.youtube.com/embed/f1ILbGzlDeQ",
    },
    {
      id: 15,
      title: "Arduino සරලව: 3 පාඩම: Servo motor - PART 2",
      link: "https://www.youtube.com/embed/Ocpz8PyeJ2E",
    },
    {
      id: 16,
      title: "Arduino සරලව: 4 පාඩම: සංවේදක (Sensors) හඳුන්වාදීම",
      link: "https://www.youtube.com/embed/94WOyegneuM",
    },
    {
      id: 17,
      title: "Arduino සරලව: 4 පාඩම: ආලෝක  සංවේදක (LDR)",
      link: "https://www.youtube.com/embed/CVN4RL3e7Gs",
    },
    {
      id: 18,
      title: "Arduino සරලව: 4 පාඩම:  සංවේදක ගැන තවත්",
      link: "https://www.youtube.com/embed/5-DefYGtB1w",
    },
    {
      id: 19,
      title: "Arduino සරලව: 4 පාඩම:  Ultrasonic Sensors",
      link: "https://www.youtube.com/embed/No6lIrvwnIk",
    },
    {
      id: 20,
      title:
        "Arduino සරලව: 5 පාඩම: පාලක පද්ධති - හැඳින්වාදීම (Control Systems)",
      link: "https://www.youtube.com/embed/VV2tP7UA1Ak",
    },
    {
      id: 21,
      title: "Arduino සරලව: 5 පාඩම: Rice Cooker",
      link: "https://www.youtube.com/embed/18tudUcUD8I",
    },
    {
      id: 22,
      title: "Arduino සරලව: 5 පාඩම: Hysteresis සමග on-off control",
      link: "https://www.youtube.com/embed/O8InOdZMUTo",
    },
    {
      id: 23,
      title: "Arduino සරලව: 5 පාඩම: Proportional (සමානුපාතික) control",
      link: "https://www.youtube.com/embed/pTyU4NeQlMw",
    },
    {
      id: 24,
      title: "Arduino සරලව: 5 පාඩම: Proportional සහ timed control",
      link: "https://www.youtube.com/embed/fN4TiIU4Bv0",
    },
    {
      id: 25,
      title: "Arduino සරලව: 5 පාඩම: Control සඳහා modes",
      link: "https://www.youtube.com/embed/LF_Qb5LctYE",
    },
  ],
}
